import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from "redux-form";
import { fetchCobiList, inputInitialize } from '../../actions/index';


class CobiInputParameters extends Component {


  constructor (props) {
    super()
    this.onButtonPress = this.onButtonPress.bind(this);
    this.checkRange = this.checkRange.bind(this);
  }

  //const className = `form-group ${touched && error ? "has-danger" : ""}`;
  componentWillMount() {


  }

  renderField(field) {
    const { meta: { touched, error } } = field;
    const className = `form-group ${touched && error ? "has-danger" : ""}`;

    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          className="form-control"
          type="text"
          {...field.input}
        />
        <div className="text-help">
          {field.meta.touched ? field.meta.error : ''}
        </div>
      </div>
    );
}

checkRange(text, min, max) {

   if (!isNaN(text) && text.toString().match(/-?\d*(\.\d+)?$/)) {
        const number = parseFloat(text);
        if ((number < min) || (number > max)) {
          return(`input is outside range  ${min}:${max}`);
        }
    } else {
      return "not a number";
    }
    return null;
  }

  onButtonPress(values) {
     //const {cell, apical, basolateral } = this.props;
     //console.log(values);
     if(this.props.fetchCobiList){
       this.props.fetchCobiList(values.p1, values.p2, values.p3, values.p4, values.p5, values.time);
     }

    }

  render() {
    //const { fields: { p1, p2, p3, p4, p5 } } = this.props;
    const { reset } = this.props;

    return (
      <form onSubmit={this.props.handleSubmit(this.onButtonPress)} >
          <Field
            style={styles.textView}
            name="p1"
            label = "Initial mass (ug)"
            component={this.renderField}
            type="text"
            keepDirtyOnReinitialize={true}
            className="form-control"

          />
            {/**logp1 3.44 onChangeText={value => this.onChanged('p1', value, -8, 8)}**/}

          <Field
            name="p2"
            component={this.renderField}
            label = "Particle size (um)"
            type="text"

            placeholder="5"
          />
            {/**c0 5 onChangeText={value => this.onChanged('p2', value, 0.1, 100000)}**/}
          <Field
            name="p3"
            component={this.renderField}
            label = 'Molecular Weight (g)'
            type="text"

            className="form-control"
          />
            {/**Vmax0 .0000029 onChangeText={value => this.onChanged('p3', value, 0, 0.01)}**/}
        <Field
          name="p4"
          component={this.renderField}
          label = 'Density (kg/m3)'
          type="text"

          className="form-control"
        />
            {/**KL 10 onChangeText={event => this.onChanged('p4', event.target.value, 0.000001, 10000)}**/}
        <Field
          name="p5"
          component={this.renderField}
          label = 'Solubility (ug/ml)'
          type="text"
          className="form-control"
        />

        <Field
          name="time"
          component={this.renderField}
          label = 'Time (s)'
          type="text"

          className="form-control"
        />
        <div flexdirection='row' style={styles.buttonView}>
        {/**<button type="button" onClick={() => inputInitialize()}>
          Load Initial Values
        </button>**/}
          <button type="submit" className="btn btn-primary" style={styles.button} > Submit </button>
          <button type="button" onClick={reset} className="btn btn-primary" style={styles.button}> Reset </button>
      </div>
      </form>
    );
  }
}

function checkRange(text, min, max) {
   if (!isNaN(text) && text.toString().match(/-?\d*(\.\d+)?$/)) {
        const number = parseFloat(text);
        if ((number < min) || (number > max)) {
          return(`input is outside range  ${min}:${max}`);
        }
    } else {
      return "not a number";
    }
    return null;
  }

function validate(values) {
  // console.log(values) -> { title: 'asdf', categories: 'asdf', content: 'asdf' }
  const errors = {};
  // Validate the inputs from 'values'
  if (!values.p1) {
    errors.p1 = "Enter first parameter";
  }
  if (!values.p2) {
    errors.p2 = "Enter second parameter";
  }
  if (!values.p3) {
    errors.p3 = "Enter third parameter";
  }
  if (!values.p4) {
    errors.p4 = "Enter fourth parameter";
  }
  if (!values.p5) {
    errors.p5 = "Enter fifth parameter";
  }
  if (!values.time) {
    errors.time = "Enter time";
  }
  /**if (values.p1){
    const rangeError = checkRange(values.p1, 1, 2.5);
    if (rangeError != null){
      errors.p1 = rangeError;
    }
  }
  if (values.p2){
    const rangeError = checkRange(values.p2, 2, 3);
    if (rangeError != null){
      errors.p2 = rangeError;
    }
  }**/
  if (values.p3){
    const rangeError = checkRange(values.p3, 300, 500);
    if (rangeError != null){
        errors.p3 = rangeError;
    }
  }

  if (values.p4){
      const rangeError = checkRange(values.p4, 1000, 1500);
      if (rangeError != null){
        errors.p4 = rangeError;
      }
  }
  if (values.p5){
    const rangeError = checkRange(values.p5, 5, 1500);
    if (rangeError != null){
      errors.p5 = rangeError;
    }
  }
  // If errors is empty, the form is fine to submit
  // If errors has *any* properties, redux form assumes form is invalid
  return errors;
}

function mapStateToProps(state) {
  return {
    initialValues: state.cobiInput
  };
}

CobiInputParameters = reduxForm({
  validate,
  form: 'CobiInputParametersForm',
  enableReinitialize: true,
  fields: ['p1', 'p2', 'p3', 'p4', 'p5','time'],
})(CobiInputParameters);

// You have to connect() to any reducers that you wish to connect to yourself
CobiInputParameters = connect(
    mapStateToProps, { fetchCobiList, inputInitialize })(CobiInputParameters);

export default CobiInputParameters;


const styles = {

  textView:{
    textAlign: "left",
    justifyContent: 'space-around',
    width: '50%',
    height: 30,
    marginRight: 10,
    margingLeft: 10,
  },
  buttonView: {
    justifyContent: 'space-around',
    paddingTop: 2,
    width: '100%',
    height: 40,
  },
  button:{
    width: '40%',
    marginRight: 10,
    margingLeft: 10,
    textAlign: "center",
  }
}



// WEBPACK FOOTER //
// ./src/components/inputViews/cobiInputParameters.js